define( 'ANSI/Utility/Dimensions', [], function () {

    var dimensions = {};

    var getDimensions = function getDimensions() {
        dimensions.height = window.innerHeight;
        dimensions.width = window.innerWidth;
        return dimensions;
    };

    window.addEventListener( 'resize', getDimensions );

    return getDimensions();

} );
